import React from 'react';
import SearchSimple from "../../SearchSimples/SearchSimple";
import AssignedItemsTableApp from "../Functionality/AssignedItemsTableApp";
import {getFullName} from "../../../Apis/functions";
import SelectedUserEmailPhoneCard from "./SelectedUserEmailPhoneCard";
import {CustomCheckbox} from "../../CustomCheckbox";
import NotInformation from "../../NotInformation";
import {IconCardFillMonitor, IconCloseChip} from "../../buttons/IconButtons";
import CustomTooltip from "../../CustomTooltip";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * Component that renders the assigned items table with search, selection,
 * bulk actions, and pagination support.
 *
 * @param {Object} props - Component properties
 * @param {string} props.keyId - Unique identifier key for each item
 * @param {Function} props.setBodyForExport - Sets the request body for export functionality
 * @param {Function} props.setSearch - Triggers advanced search behavior
 * @param {Function} props.setSimpleSearch - Triggers simple search behavior
 * @param {Array} props.selected - List of selected item IDs
 * @param {Function} props.setSelected - Updates selected items
 * @param {Object} props.results - Data source containing assigned items and pagination info
 * @param {Function} props.setResults - Updates the results state
 * @param {string} props.searchElement - Current search input value
 * @param {Function} props.setSearchElement - Updates the search input value
 * @param {string} props.labelRowsPerPage - Label for rows per page in pagination
 * @param {Function} props.onDelete - Handles deletion of individual items
 * @param {string} props.tableNotInformationLegend - Message displayed when no data is available
 * @param {Function} props.tableBuildBody - Function to build request body for API calls
 * @param {Function} props.tableEndPoint - Endpoint function to fetch assigned items
 * @param {string} props.viewTypeName - View type identifier for rendering variations
 * @param {boolean} props.modified - Indicates if the data has been modified
 * @param {Function} props.setModified - Updates the modified state
 * @param {boolean} props.isAllChecked - Indicates if all items are selected
 * @param {Function} props.setIsAllChecked - Updates the "select all" state
 * @param {Function} props.checkbox - Show/ hide checkbox
 * @param {Function} props.renderAssignedItem - Function used to render each assigned item row
 * @param {JSX.Element} [props.renderModuleTitle] - Optional module title node; when set it is rendered inline before the search on the same row
 * @returns {JSX.Element} Assigned items table component
 */
const AssignedItemsTable = (props) => {

    const {
        keyId,
        setBodyForExport,
        setSearch,
        setSimpleSearch,
        selected,
        setSelected,
        results,
        setResults,
        searchElement,
        setSearchElement,
        labelRowsPerPage,
        onDelete,
        tableNotInformationLegend,
        tableBuildBody,
        tableEndPoint,
        viewTypeName,
        modified,
        setModified,
        isAllChecked,
        setIsAllChecked,
        checkbox,
        renderAssignedItem,
        searchTitle= "search_by_name_email_or_phone",
        renderModuleTitle
    } = props;


    const {
        t,
        pagination,
        rowsPerPage,
        elementRef,
        getData,
        handleDeleteAll,
        handleCheckboxChange
    } = AssignedItemsTableApp({
        keyId,
        results,
        setResults,
        searchElement,
        labelRowsPerPage,
        tableBuildBody,
        tableEndPoint,
        viewTypeName,
        modified,
        setModified,
        setIsAllChecked,
        selected,
        setSelected
    });

      const searchSimple = (
          <SearchSimple
              id={'txt_ait_search_employees'}
              label={searchTitle}
              setBodyForExport={setBodyForExport}
              setSearchResults={setResults}
              searchElement={searchElement}
              setSearchElement={setSearchElement}
              rowsPerPage={rowsPerPage}
              setSearch={setSearch}
              setSimpleSearch={setSimpleSearch}
              contractorId={null}
              supplierId={null}
              callApi={() => getData(0, { searchElement })}
              resetApi={() => getData(0, { searchElement: '' })}
          />
      );
      return (
          <>
              {renderModuleTitle ? (
                  <div className={'d-flex align-items-center gap-3 mb-3'}>
                      {renderModuleTitle}
                      <div className={'flex-grow-1 minw-0'}>{searchSimple}</div>
                  </div>
              ) : (
                  searchSimple
              )}
              {checkbox && (
                  <div className={'mb-3'}>
                      <CustomCheckbox
                          id={'cb_cc_de_select_all'}
                          trans={t('de_/_select_all')}
                          checked={isAllChecked}
                          onChange={handleDeleteAll}
                          marginbutton={true}
                      />
                  </div>
              )}
              {results?.content?.length > 0 ? (
                  <div className='panelTables-container custom-scrollbar' ref={elementRef}>
                      <div className='row m-0 p-0'>
                          {results?.content?.map((item, index) => {
                              return (
                                  <div
                                      key={item[keyId] || index}
                                      className={`col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4 px-2 mb-3 cursor-pointer`}
                                  >
                                      {renderAssignedItem ? (
                                          renderAssignedItem({
                                              item,
                                              keyId,
                                              onDelete,
                                              checkbox,
                                              handleCheckboxChange,
                                              selected
                                          })
                                      ) : (
                                          <SelectedUserEmailPhoneCard
                                              keyId={keyId}
                                              item={{
                                                  [keyId]: item[keyId],
                                                  fullName:
                                                      item?.fullName ||
                                                      getFullName(
                                                          item?.name,
                                                          item?.firstLastName,
                                                          item?.secondLastName,
                                                      ),
                                                  email: item?.email,
                                                  phoneNumber: item?.phoneNumber,
                                                  disabled: false,
                                                  checked: selected.includes(item[keyId]),
                                              }}
                                              onDelete={onDelete}
                                              handleCheckboxChange={checkbox ? handleCheckboxChange : undefined}
                                          />
                                      )}
                                  </div>
                              );
                          })}
                      </div>
                  </div>
              ) : (
                  <NotInformation text={t(tableNotInformationLegend)} className={'h-100'} card={true} />
              )}
              {pagination()}
          </>
      );

}
export default AssignedItemsTable
